export function manipulateUrl(url: string): string {
  const hasRule = import.meta.env[`VITE_${getTenant()}_winex`] as number;
  if (hasRule === undefined) {
    return url;
  }
  const rules = String.raw`^(?!.*winex);winex://;\\;/`;
  const regexRules: { regex: RegExp; replacement: string }[] = [];
  const rulePairs = rules.split(';');
  // Parse the rule pairs
  for (let i = 0; i < rulePairs.length; i += 2) {
    const regexPattern = rulePairs[i];
    const replacement = rulePairs[i + 1];
    const regex = new RegExp(regexPattern, 'g');
    regexRules.push({ regex, replacement });
  }
  // Apply the regex replacements
  for (const { regex, replacement } of regexRules) {
    url = url.replace(regex, replacement);
  }

  return url;
}

export function hasRules(): boolean {
  return import.meta.env[`VITE_${getTenant()}_winex`] !== undefined;
}

export function hasMirroredEnabled(): boolean {
  return (
    import.meta.env[`VITE_${getTenant()}_Feature_Flag_Mirror`] !== undefined &&
    import.meta.env[`VITE_${getTenant()}_Feature_Flag_Mirror`] === '1'
  );
}

/**
 * Get the OAuth redirect URI for Microsoft integrations (Planner, Todo, SharePoint)
 * Returns localhost URL in development, otherwise returns the current hostname
 */
export function getRedirectURI(): string {
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:4000';
  }
  if (!hostname.endsWith('beeboard.eu')) {
    throw new Error('Cannot integrate this domain');
  }
  const host = window.location.hostname;

  return `https://${host}`;
}

/**
 * Get the current tenant identifier from the hostname
 *
 * Returns the subdomain from URLs like: https://{tenant}.beeboard.eu
 * Defaults to 'beeboard' for localhost and bare domains
 *
 * @example
 * // URL: https://instone.beeboard.eu
 * getTenant() // 'instone'
 *
 * // URL: http://localhost:4000
 * getTenant() // 'beeboard'
 */
export function getTenant() {
  const BEEBOARD_ACCOUNT = 'beeboard';
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return BEEBOARD_ACCOUNT;
  }
  if (!hostname.endsWith('beeboard.eu')) {
    throw new Error('Cannot integrate this domain');
  }
  const splittedHostname = window.location.hostname.split('.');
  if (splittedHostname.length !== 3) {
    return BEEBOARD_ACCOUNT;
  }
  const subdomain = splittedHostname[0];

  return subdomain;
}

/**
 * Removes both leading and trailing slashes from a URL or path string.
 * Handles multiple consecutive slashes.
 *
 * @example
 * trimSlashes('/path/to/file/') // 'path/to/file'
 * trimSlashes('///path///') // 'path'
 * trimSlashes('https://example.com/path/') // 'https://example.com/path'
 * trimSlashes(null) // null
 */
export function trimSlashes(
  url: string | null | undefined,
): string | null | undefined {
  if (!url) {
    return url;
  }

  return url.replace(/^\/+|\/+$/g, '');
}
